import { faUser } from "@fortawesome/free-solid-svg-icons";
import React from "react";

import i18n from "../../../../constants/i18n";
import { TRANSFER_PACKAGE_TYPE_OPTIONS } from "../../../../constants/picker-entries-constants";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getTransferUserPackageStore from "../../../../stores/developer-store/transfer-user-package-store";
import { StringOrNumber } from "../../../../Types";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";

const TransferUserPackageForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { unitX, unitY } = theme;
  const inputStyle = {
    minWidth: 250 * unitX,
    minHeight: 45 * unitY,
    width: 250 * unitX,
    height: 45 * unitY
  };

  return (
    <React.Fragment>
      <Et3TextInput
        size="MEDIUM"
        withShadow={false}
        icon={faUser}
        type={"number"}
        label={i18n.get("FROM_USER_ID")}
        placeHolder={i18n.get("FROM_USER_ID")}
        value={getTransferUserPackageStore().fromUserId.get()}
        onChoose={(value: StringOrNumber) => {
          getTransferUserPackageStore().setFromUserId(value);
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={inputStyle}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3TextInput
        size="MEDIUM"
        withShadow={false}
        icon={faUser}
        type={"number"}
        label={i18n.get("TO_USER_ID")}
        placeHolder={i18n.get("TO_USER_ID")}
        value={getTransferUserPackageStore().toUserId.get()}
        onChoose={(value: StringOrNumber) => {
          getTransferUserPackageStore().setToUserId(value);
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={inputStyle}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Picker
        label={i18n.get("PACKAGE_TYPE")}
        options={TRANSFER_PACKAGE_TYPE_OPTIONS}
        value={getTransferUserPackageStore().packageType.get()}
        onChoose={(value: TEt3PickerSingleValue) => {
          getTransferUserPackageStore().setPackageType(value);
        }}
        isMultiple={false}
        style={{}}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={getTransferUserPackageStore().isTransferEnabled.get()}
        onClick={async () => {
          await getTransferUserPackageStore().openTransferConfirmation();
        }}
        size="LARGE"
        text="TRANSFER_USER_PACKAGE"
        type="REJECT"
      />
    </React.Fragment>
  );
});

export default TransferUserPackageForm;
